import React from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";

// O tema efetivo do app vive em context/DarkMode (src/theme.js).
// Este componente só monta as rotas.
const App = () => {
	return <Routes />;
};

export default App;
